var __TEMP__ = require('./_asciiToArray.js');var asciiToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hasUnicode.js');var hasUnicode = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_unicodeToArray.js');var unicodeToArray = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = stringToArray;
